import {
  MoreVerticalOutlineIcon,
  OpenInNew1OutlineIcon,
  RefreshOutlineIcon,
} from '@carboncopyco/icons';
import {
  ColorHex,
  Dropdown,
  DropdownItem,
  Loading,
  TextBase,
  TextCaption,
} from '@carboncopyco/ui';
import classNames from 'classnames';

type UpdateTableButtonProps = {
  isLoading: boolean;
  onClick: () => void;
  openSpreadsheet: () => void;
};

export const UpdateTableButton = ({
  isLoading,
  onClick,
  openSpreadsheet,
}: UpdateTableButtonProps) => {
  return (
    <div
      className={classNames(
        'flex items-center gap-1',
        !isLoading && 'cursor-pointer'
      )}
    >
      <span
        className="flex"
        onClick={() => {
          if (isLoading) return;
          onClick();
        }}
      >
        <TextCaption
          label={isLoading ? 'Updating...' : 'Update changes'}
          color={isLoading ? 'text-ds-natural-200' : 'text-ds-primary-300'}
        />
      </span>
      {isLoading ? (
        <Loading
          color="text-ds-primary-300"
          size={16}
        />
      ) : (
        <RefreshOutlineIcon
          size={16}
          color={ColorHex.primary300}
        />
      )}
      {!isLoading && (
        <Dropdown
          triggerElement={
            <span className="cursor-pointer">
              <MoreVerticalOutlineIcon
                size={16}
                color={ColorHex.natural300}
              />
            </span>
          }
        >
          <DropdownItem
            onClick={openSpreadsheet}
            label={
              <TextBase
                label="Open source"
                color="text-ds-natural-600"
              />
            }
            iconLeft={
              <OpenInNew1OutlineIcon
                size={20}
                color={ColorHex.natural600}
              />
            }
          />
        </Dropdown>
      )}
    </div>
  );
};
